module.exports = __webpack_public_path__ + "img/webstorm.b40897f2.svg";